import { Component, inject, Input } from '@angular/core';
import { TelegramFileUrlService } from "../../../../services/telegram-file-url.service";
import { MessageTelegram } from "../../../../types/last-message.types";
import { TelegramModalsService } from "../../../../services/telegram-modals.service";
import { MatMiniFabButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'app-telegram-message-image',
  standalone: true,
  imports: [
    MatMiniFabButton,
    MatIcon
  ],
  templateUrl: './telegram-message-image.component.html',
  styleUrl: './telegram-message-image.component.scss'
})
export class TelegramMessageImageComponent {
  @Input({ required: true }) message!: MessageTelegram;

  private telegramFileUrlService: TelegramFileUrlService = inject(TelegramFileUrlService);
  private telegramModalsService: TelegramModalsService = inject(TelegramModalsService);

  public getImage(id: string): string {
    return this.telegramFileUrlService.imageUrlsSignal()[id] || '';
  }

  public handleOpenImage(id: string): void {
    const url = this.getImage(id);
    if (!url) {
      return;
    }

    this.telegramModalsService.openTelegramImageModal(url)
  }
}
